// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/density.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/shell.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Container */
.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Main Content Area */
.app-main {
  animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Page Container */
.container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 var(--space-lg);
  width: 100%;
}

/* Loading Container (shown while checking maintenance mode) */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

/* Dev Server Banner */
.dev-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ff9800;
  color: #000;
  padding: 10px 20px;
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  z-index: 10000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  border-bottom: 3px solid #f57c00;
}

/* Container offset when dev banner is visible */
.container--with-dev-banner {
  margin-top: 50px;
}

/* Alert Modal Shared Styles */
.alert-modal {
  max-width: 500px;
  padding: 40px;
  text-align: center;
  color: white;
  border-radius: 16px;
}

.alert-modal__icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.alert-modal__title {
  margin: 0 0 15px 0;
  font-size: 24px;
  font-weight: 700;
}

.alert-modal__message {
  margin: 0 0 30px 0;
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.95;
}

.alert-modal__btn {
  padding: 12px 32px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.alert-modal__btn:hover {
  transform: scale(1.05);
}

/* Donation Alert Modal */
.donation-alert-modal--success {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.donation-alert-modal--cancelled {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.donation-alert-modal__btn--success {
  background: white;
  color: #667eea;
}

.donation-alert-modal__btn--cancelled {
  background: white;
  color: #f5576c;
}

/* Competition Phase Alert Modal */
.competition-alert-modal--submission {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.competition-alert-modal--voting {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.competition-alert-modal__btn-primary--submission {
  background: white;
  color: #11998e;
  margin-right: 10px;
}

.competition-alert-modal__btn-primary--voting {
  background: white;
  color: #667eea;
  margin-right: 10px;
}

.competition-alert-modal__btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid white;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAIA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,WAAW;AACb;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,uBAAuB;AACzB","sourcesContent":["@import './styles/variables.css';\n@import './styles/density.css';\n@import './styles/shell.css';\n\n/* App Container */\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Main Content Area */\n.app-main {\n  animation: fadeIn 0.4s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Page Container */\n.container {\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 0 var(--space-lg);\n  width: 100%;\n}\n\n/* Loading Container (shown while checking maintenance mode) */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n/* Dev Server Banner */\n.dev-banner {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: #ff9800;\n  color: #000;\n  padding: 10px 20px;\n  text-align: center;\n  font-weight: bold;\n  font-size: 1.2rem;\n  z-index: 10000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  border-bottom: 3px solid #f57c00;\n}\n\n/* Container offset when dev banner is visible */\n.container--with-dev-banner {\n  margin-top: 50px;\n}\n\n/* Alert Modal Shared Styles */\n.alert-modal {\n  max-width: 500px;\n  padding: 40px;\n  text-align: center;\n  color: white;\n  border-radius: 16px;\n}\n\n.alert-modal__icon {\n  font-size: 48px;\n  margin-bottom: 20px;\n}\n\n.alert-modal__title {\n  margin: 0 0 15px 0;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.alert-modal__message {\n  margin: 0 0 30px 0;\n  font-size: 16px;\n  line-height: 1.6;\n  opacity: 0.95;\n}\n\n.alert-modal__btn {\n  padding: 12px 32px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.alert-modal__btn:hover {\n  transform: scale(1.05);\n}\n\n/* Donation Alert Modal */\n.donation-alert-modal--success {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.donation-alert-modal--cancelled {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n}\n\n.donation-alert-modal__btn--success {\n  background: white;\n  color: #667eea;\n}\n\n.donation-alert-modal__btn--cancelled {\n  background: white;\n  color: #f5576c;\n}\n\n/* Competition Phase Alert Modal */\n.competition-alert-modal--submission {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n}\n\n.competition-alert-modal--voting {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.competition-alert-modal__btn-primary--submission {\n  background: white;\n  color: #11998e;\n  margin-right: 10px;\n}\n\n.competition-alert-modal__btn-primary--voting {\n  background: white;\n  color: #667eea;\n  margin-right: 10px;\n}\n\n.competition-alert-modal__btn-secondary {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
